/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdatePalReauthEmrDocumentSelection200ResponseData
 */
export interface UpdatePalReauthEmrDocumentSelection200ResponseData {
    /**
     * 
     */
    external_emr_document_id: string;
    /**
     * 
     */
    is_selected: boolean;
}

/**
 * Check if a given object implements the UpdatePalReauthEmrDocumentSelection200ResponseData interface.
 */
export function instanceOfUpdatePalReauthEmrDocumentSelection200ResponseData(value: object): value is UpdatePalReauthEmrDocumentSelection200ResponseData {
    if (!('external_emr_document_id' in value) || value['external_emr_document_id'] === undefined) return false;
    if (!('is_selected' in value) || value['is_selected'] === undefined) return false;
    return true;
}

export function UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSON(json: any): UpdatePalReauthEmrDocumentSelection200ResponseData {
    return UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSONTyped(json, false);
}

export function UpdatePalReauthEmrDocumentSelection200ResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePalReauthEmrDocumentSelection200ResponseData {
    if (json == null) {
        return json;
    }
    return {
        
        'external_emr_document_id': json['external_emr_document_id'],
        'is_selected': json['is_selected'],
    };
}

export function UpdatePalReauthEmrDocumentSelection200ResponseDataToJSON(json: any): UpdatePalReauthEmrDocumentSelection200ResponseData {
    return UpdatePalReauthEmrDocumentSelection200ResponseDataToJSONTyped(json, false);
}

export function UpdatePalReauthEmrDocumentSelection200ResponseDataToJSONTyped(value?: UpdatePalReauthEmrDocumentSelection200ResponseData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'external_emr_document_id': value['external_emr_document_id'],
        'is_selected': value['is_selected'],
    };
}

